export default __webpack_public_path__ + "static/media/purpleLogo2.cb65f525.png";